import { useDispatch, useSelector } from "react-redux";
import { useCallback, useContext, useState } from "react";

import { ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { LocalizerContext } from "@com.mgmtp.a12.utils/utils-localization-react/lib/main";
import { HeaderTrigger } from "@com.mgmtp.a12.widgets/widgets-core/lib/button/main/header-trigger/header-trigger.view";
import { Icon } from "@com.mgmtp.a12.widgets/widgets-core/lib/icon/main/icon.view";
import { List } from "@com.mgmtp.a12.widgets/widgets-core/lib/list/main/list.view";
import { PopUpMenu } from "@com.mgmtp.a12.widgets/widgets-core/lib/pop-up-menu/main/pop-up-menu.view";

import { version } from "../config";
import { Descriptors } from "../config/const";
import { RESOURCE_KEYS } from "../localization";
import { selectEnvironmentData } from "../app/slices/environmentData/selectors";

const INFO_RESOURCE_KEYS = RESOURCE_KEYS.application.header.info;

export function openInNewTab(url: string): void {
	window.open(url, "_blank", "noopener,noreferrer");
}

/**
 * Rendert das User-Menü oben rechts im Hauptmenü, mit Profilnamen, Logout-button, etc.
 */
export const InfoHeader = () => {
	const dispatch = useDispatch();
	const [isPopupButtonActive, setPopupButtonActive] = useState(false);
	const { localizer } = useContext(LocalizerContext);

	const lastActivity = useSelector(ActivitySelectors.latestActivity());
	const { documentsUrl } = useSelector(selectEnvironmentData);
	const openDocumentsUrl = useCallback(() => {
		if (documentsUrl) {
			openInNewTab(documentsUrl);
		}
	}, [documentsUrl]);
	const onAccessibilityClick = useCallback(
		() =>
			dispatch(
				ActivityActions.create({
					activityDescriptor: Descriptors.accessibilityPage,
					loadingState: "without",
					initiatingActivityId: lastActivity?.id
				})
			),
		[dispatch, lastActivity?.id]
	);

	return (
		<PopUpMenu
			triggerButtonTitle={localizer({ key: INFO_RESOURCE_KEYS.title })}
			triggerElement={
				<HeaderTrigger active={isPopupButtonActive} graphic="info" className="force-plasma-icon-outlined" />
			}
			onVisibilityChange={setPopupButtonActive}
		>
			<List>
				{!!documentsUrl && (
					<List.Item
						text={localizer({ key: INFO_RESOURCE_KEYS.documents.label })}
						htmlAttributes={{
							"aria-label": localizer({ key: INFO_RESOURCE_KEYS.documents.accessibilityLabel })
						}}
						meta={<Icon>open_in_new</Icon>}
						graphic={<Icon>menu_book</Icon>}
						onClick={openDocumentsUrl}
						divider
					/>
				)}
				<List.Item
					text={localizer({ key: INFO_RESOURCE_KEYS.version.label })}
					secondaryText={version}
					graphic={<Icon>numbers</Icon>}
					readonly
					divider
				/>
				<List.Item
					text={localizer({ key: INFO_RESOURCE_KEYS.accessibility.label })}
					graphic={<Icon>accessibility_new</Icon>}
					onClick={onAccessibilityClick}
					divider
				/>
			</List>
		</PopUpMenu>
	);
};
